"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconReadyForTheFuture = function IconReadyForTheFuture(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m41.06 6.244-1.138.09c-.27.02-.746.081-1.4.201a28 28 0 0 0-3.55.91c-3.651 1.183-7.3 3.082-10.705 5.856a35 35 0 0 0-3.522 3.306l-5.908.674-9.93 8.341 10.15-.944a44 44 0 0 0-1.106 2.234l-.29.63 2.542 2.56-2.27 2.27 1.414 1.415 2.265-2.265 2.52 2.538.635-.291a42 42 0 0 0 2.19-1.082l-1.401 9.617 8.9-9.378.697-6.105a33.6 33.6 0 0 0 3.312-3.667 32.6 32.6 0 0 0 5.548-10.787c.382-1.291.647-2.492.818-3.574l.061-.412c.054-.385.085-.688.1-.899zM16.264 22.557a38 38 0 0 1 2.577-3.72l-3.179.362-4.57 3.839zm8.18 13.798.718-4.93a37 37 0 0 0 3.754-2.644l-.372 3.252zm-3.167-8.498-2.25 2.251 1.535 1.547.534-.26c4.77-2.374 8.546-5.437 11.446-9.034l.344-.434a30.6 30.6 0 0 0 5.21-10.127c.355-1.205.602-2.32.76-3.318l-.006.026-.344.067c-.892.18-1.87.433-2.917.772-3.427 1.11-6.856 2.895-10.059 5.505-3.66 2.983-6.785 6.86-9.213 11.75l-.255.52 1.555 1.567 2.246-2.246zM27.73 16.06a2.5 2.5 0 1 0 3.535 3.535 2.5 2.5 0 0 0-3.535-3.535m.707.707a1.5 1.5 0 1 1 2.121 2.121 1.5 1.5 0 0 1-2.121-2.121M13.524 34.904l-.707-.708-5.93 5.93.707.708zm3.903.212.707.708-5.93 5.93-.708-.707zm-4.823-4.822-.708-.708-5.93 5.93.708.708z",
    clipRule: "evenodd"
  })));
};

export { IconReadyForTheFuture, IconReadyForTheFuture as default };
